import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useRootTranslation } from 'utils/hooks';

const rootT = 'drawers.tracksImportResolver';

type StatusPillProps = { matched: boolean };

const StatusPill = ({ matched }: StatusPillProps) => {
  const t = useRootTranslation(rootT);

  return (
    <Box
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color: matched ? 'success.main' : 'error.main' }}
    >
      {matched && <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />}
      <Typography variant="caption" sx={{ fontWeight: 700 }}>
        {matched ? t('status.matched') : t('status.unmatched')}
      </Typography>
    </Box>
  );
};

export default StatusPill;
